// ----------------------------------------------------------------------
// <copyright file="Izenda.FormatItemPropertiesSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  require('share/utils/Izenda.StringUtilities');
  var m = require('mobx');
  var commonDataStore = require('logic/Izenda.ReportDesignerCommonDataStore');
  var CONSTANTS = require('logic/data/Izenda.ReportDesignerFormatsConstants');
  var DEFAULT_GROUP_BY = 'category';
  var localizer = require('share/localization/Izenda.Localizer');
  const { isNil, find, get } = require('lodash/fp');

  var SCHEMA_DEF = {
    schemaKey: 'FORMAT_ITEM_PROPERTIES',
    props: {
      className: 'form-horizontal'
    },
    fields: {
      generalInfo: {
        component: 'Panel',
        props: {
          initState: true,
          collapsible: true,
          header: {
            get title() {
              return localizer.getText('COMMON_LABEL_GENERAL_INFO');
            },
            icon: 'icon-toggle-triangle'
          }
        },
        fields: {
          label: {
            get title() {
              return localizer.getText('FORMAT_PROPERTIES_LABEL_ITEM_TYPE');
            },
            type: 'static',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType',
            props: {
              field: 'label'
            }
          },

          name: {
            get title() {
              return localizer.getText('FORMAT_PROPERTIES_LABEL_ITEM_NAME');
            },
            component: 'CustomInput',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType',
            props: {
              validations: 'getFormatNameValidation',
              field: 'name'
            }
          },

          value: {
            get title() {
              return localizer.getText('FORMAT_PROPERTIES_LABEL_ITEM_VALUE');
            },
            component: 'InputByDataType',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType',
            props: {
              type: 'getInputByDataType',
              validations: {
                presence: {
                  presence: true,
                  message: localizer.getText('FORMAT_PROPERTIES_MESSAGE_ITEM_VALUE_REQUIRED')
                }
              },
              onBlur: 'validateItemValue',
              field: 'value'
            }
          },

          imageUrl: {
            get title() {
              return localizer.getText('FORMAT_PROPERTIES_LABEL_IMAGE_URL');
            },
            component: 'CustomInput',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType',
            props: {
              validations: {
                presence: {
                  presence: true,
                  get message() {
                    return localizer.getText('FORMAT_PROPERTIES_MESSAGE_IMAGE_URL_REQUIRED');
                  }
                }
              },
              field: 'urlImage'
            }
          },

          imageDimensions: {
            get title() {
              return localizer.getText('FORMAT_PROPERTIES_LABEL_IMAGE_DIMENSIONS');
            },
            component: 'ImageDimensions',
            fnValue: 'getDimensions',
            isHidden: 'showByFormatType',
            field: 'imageDimensions'
          },

          defaultImgBtn: {
            get title() {
              return ' ';
            },
            component: 'Button',
            isHidden: 'shouldDefaultImgBtnHidden',
            props: {
              label: localizer.getText('FORMAT_PROPERTIES_LABEL_DEFAULT_IMAGE_BUTTON'),
              onClick: 'loadDefaultImageUrl'
            }
          }
        }
      },
      itemFormat: {
        component: 'Panel',
        props: {
          initState: true,
          collapsible: true,
          header: {
            get title() {
              return localizer.getText('FORMAT_PROPERTIES_LABEL_ITEM_FORMATTING');
            },
            icon: 'icon-toggle-triangle'
          }
        },
        fields: {
          format: {
            get title() {
              return localizer.getText('COMMON_LABEL_FORMAT');
            },
            type: 'select',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType',
            props: {
              options: 'getDataFormats',
              labelField: 'name',
              valueField: 'name',
              groupBy: 'getGroupBy',
              showTooltip: true,
              blankOption: true,
              blankOptionText: '...'
            }
          },
          // font family + font size
          fontFormat: {
            get title() {
              return localizer.getText('FONT_SETTINGS_LABEL_FONT');
            },
            component: 'Font',
            fnValue: 'getFontFormat',
            isHidden: 'showByFormatType',
            props: {
              position: 'left'
            }
          },

          alignment: {
            get title() {
              return localizer.getText('FONT_SETTINGS_LABEL_ALIGNMENT');
            },
            component: 'AlignmentSetting',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType'
          },
          dashStyle: {
            get title() {
              return localizer.getText('BORDER_SETTING_LABEL_DASH_STYLE');
            },
            component: 'DashStyle',
            isHidden: 'showByFormatType',
            props: {
              dashStyle: 'getValueByKey'
            }
          },
          color: {
            get title() {
              return localizer.getText('COMMON_LABEL_COLOR');
            },
            component: 'ColorPicker',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType',
            props: {
              position: 'left'
            }
          },
          thickness: {
            get title() {
              return localizer.getText('BORDER_SETTING_LABEL_THICKNESS');
            },
            component: 'Thickness',
            fnValue: 'getValueByKey',
            isHidden: 'showByFormatType'
          }
        }
      }
    }
  };

  var WIDGETS = {
    Panel: require('share/components/controls/Izenda.Panel'),
    AlignmentSetting: require('share/components/controls/Izenda.AlignmentSetting'),
    Font: require('share/components/controls/Izenda.Font'),
    ColorPicker: require('share/components/controls/Izenda.ColorPicker'),
    Thickness: require('share/components/controls/Izenda.Thinkness'),
    DashStyle: require('share/components/controls/Izenda.DashStyle'),
    InputByDataType: require('share/components/controls/Izenda.InputByDataType'),
    CustomInput: require('share/components/controls/Izenda.CustomInput'),
    Button: require('share/components/controls/Izenda.Button'),
    ImageDimensions: require('share/components/controls/Izenda.ImageDimensions')
  };

  module.exports = function(reportDesignerModel, item, valManager) {
    ensure(!!reportDesignerModel, 'reportDesignerModel must be set');

    var formatType = item.type;

    var validateFormatName = function(newName) {
      var selectedFormatGroup = reportDesignerModel.reportFields.selectedFormatGroup;
      var selectedFormatItem = reportDesignerModel.reportFields.selectedFormatItem;
      var formatItems = reportDesignerModel.reportFields[selectedFormatGroup];
      var isExisting =
        formatItems.checkExistingFormatItemName && formatItems.checkExistingFormatItemName(newName, selectedFormatItem);

      var formatGroup =
        find(
          function(item) {
            return item.value === selectedFormatGroup;
          }.bind(this),
          CONSTANTS.FORMAT_GROUP
        ) || {};
      var formatGroupName = formatGroup.label;

      var message = String.format(CONSTANTS.MESSAGES.M01, formatGroupName);

      if (isExisting) {
        return Promise.resolve(message);
      }
      return Promise.resolve('');
    };

    return {
      // define data to render UI
      definedSchema: SCHEMA_DEF,

      // list of widgets which are used to render UI
      widgets: WIDGETS,

      // data to binding to fields
      source: item,

      // properties for different fields
      mappingProps: {
        validateItemValue: function() {
          valManager.validate().then(function(success) {
            if (success) {
              valManager.reset();
            }
            return success;
          });
        },

        loadDefaultImageUrl: function() {
          if (!isNil(reportDesignerModel.defaultImageUrl.value)) {
            item.updateValueByKey('imageUrl', reportDesignerModel.defaultImageUrl.value);
          }
        }
      },

      // defined-function which fields need to execute to get its data
      mappingSource: {
        getFormatNameValidation: function() {
          return {
            presence: {
              presence: true,
              message: localizer.getText('REPORTDESIGNER_MESSAGE_ITEM_NAME_REQUIRED')
            },
            action: m.asReference(function() {
              return validateFormatName;
            })
          };
        },

        getDimensions: function() {
          const dimension = item.imageDimensions|| {
            imageWidth: 1,
            imageHeight: 1,
            isConstrainProportions: true
          };
          
          return {
            imageHeight: dimension.imageHeight,
            imageWidth: dimension.imageWidth,
            isConstrainProportions: dimension.isConstrainProportions
          };
        },

        /**
         * Show hide config properties
         * @param  {string} optName
         * @return {boolean}
         */
        showByFormatType: function(optName) {
          var OPTIONS_BY_FORMAT_TYPE = CONSTANTS.OPTIONS_BY_FORMAT_TYPE;
          var defaultFormatOptionByType = OPTIONS_BY_FORMAT_TYPE[formatType];
          return isNil(defaultFormatOptionByType) ? true : !defaultFormatOptionByType.hasOwnProperty(optName);
        },

        /**
         * Get input control by item
         * @return {string}
         */
        getInputByDataType: function() {
          if (formatType === 'text') {
            return 'text';
          } else {
            return 'static';
          }
        },

        /**
         * Get data format item
         * @return {array}
         */
        getDataFormats: function() {
          return commonDataStore.loadReportFieldDataFormat(formatType);
        },

        /**
         * Get option group by
         * @return {string}
         */
        getGroupBy: function() {
          if (formatType === CONSTANTS.ITEMS_TYPE.pageNumber.value) {
            return null;
          } else {
            return DEFAULT_GROUP_BY;
          }
        },

        getFontFormat: function() {
          var fontFormat = item.font || {};
          return {
            backgroundColor: fontFormat.backgroundColor,
            color: fontFormat.color,
            format: {
              fontFamily: fontFormat.family,
              fontSize: fontFormat.size
            },
            style: {
              fontBold: fontFormat.bold,
              fontItalic: fontFormat.italic,
              fontUnderline: fontFormat.underline
            }
          };
        },

        /**
         * Show hide default image button
         * @param  {string} optName
         * @return {boolean}
         */
        shouldDefaultImgBtnHidden: function(optName) {
          return (
            this.showByFormatType(optName) ||
            isNil(reportDesignerModel.defaultImageUrl.value) ||
            reportDesignerModel.defaultImageUrl.value === ''
          );
        }
      },

      // mapping data from editor to report-designer- model
      onChangeValue: function(
        schemaData: Object,
        changedKey: any,
        changedKeyPath: any,
        changedValue: any,
        changedOthersInfo: any
      ) {
        var groupData = changedKeyPath && changedKeyPath.length ? get(changedKeyPath, schemaData) : schemaData;
        var fieldData = groupData[changedKey];

        fieldData && (fieldData.value = changedValue);

        var itemDetail = item;
        var generalInfo = schemaData.generalInfo;
        var itemFormat = schemaData.itemFormat;
        var fontFormat = itemFormat.fontFormat.value || {};
        var fontFamily = fontFormat.format || {};
        var fontStyle = fontFormat.style || {};
        if (changedKey === 'imageUrl') {
          getMeta(generalInfo.imageUrl.value, function(width, height) {
            generalInfo.imageDimensions.value = {
              imageWidth: width,
              imageHeight: height,
              isConstrainProportions: generalInfo.imageDimensions.value.isConstrainProportions
            };
            item.updateValueByKey('imageDimensions', {
              imageWidth: width,
              imageHeight: height,
              isConstrainProportions: generalInfo.imageDimensions.value.isConstrainProportions
            });
          });
        }
        itemDetail.setItemsDetails({
          name: generalInfo.name.value,
          value: generalInfo.value.value,
          imageUrl: generalInfo.imageUrl.value,
          format: itemFormat.format.value,
          alignment: itemFormat.alignment.value,
          color: itemFormat.color.value,
          dashStyle: itemFormat.dashStyle.value,
          thickness: itemFormat.thickness.value,
          family: fontFamily.fontFamily,
          size: fontFamily.fontSize,
          bold: fontStyle.fontBold,
          italic: fontStyle.fontItalic,
          underline: fontStyle.fontUnderline,
          textColor: fontFormat.color,
          textBackgrounColor: fontFormat.backgroundColor,
          imageDimensions: generalInfo.imageDimensions.value
        });
      }
    };
  };
})();

function getMeta(url, callback) {
  var img = new Image();
  img.src = url;
  img.onload = function() {
    callback(this.width, this.height);
  };
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Formats/Izenda.FormatItemPropertiesSchema.js